import TipeUjian from "../../../../../components/categories/siakad/lms/data_matpel/subpage/tipe_ujian/Home";
export default function Home() {
  
  return (
    <TipeUjian />
  );
}
